import script from "./WebHackingNaPratica.vue?vue&type=script&setup=true&lang=ts"
export * from "./WebHackingNaPratica.vue?vue&type=script&setup=true&lang=ts"

import "./WebHackingNaPratica.vue?vue&type=style&index=0&id=428bacaa&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-428bacaa"]])

export default __exports__